import { Address } from '../globals/address';
import { PageKey } from '../globals/page-key';

export const routesOrder: {
  [key in PageKey]?: { nextRoute: PageKey; prevRoute: PageKey };
} = {
  [PageKey.useMyApproval]: { nextRoute: PageKey.none, prevRoute: PageKey.toc },
  [PageKey.landing]: { nextRoute: PageKey.contactInfo, prevRoute: PageKey.none },
  [PageKey.onboarding]: { nextRoute: PageKey.toc, prevRoute: PageKey.none },
  [PageKey.toc]: { nextRoute: PageKey.contactInfo, prevRoute: PageKey.onboarding },
  [PageKey.contactInfo]: { nextRoute: PageKey.personalInfo, prevRoute: PageKey.toc },
  [PageKey.personalInfo]: { nextRoute: PageKey.incomeInfo, prevRoute: PageKey.contactInfo },
  [PageKey.addressInfo]: { nextRoute: PageKey.incomeInfo, prevRoute: PageKey.personalInfo },
  [PageKey.incomeInfo]: { nextRoute: PageKey.cardInfo, prevRoute: PageKey.personalInfo },
  [PageKey.cardInfo]: { nextRoute: PageKey.bankInfo, prevRoute: PageKey.incomeInfo },
  // Address info will be used if not pre-populated by merchant. Need to handle logic in future.
  [PageKey.bankInfo]: { nextRoute: PageKey.review, prevRoute: PageKey.cardInfo },
  [PageKey.review]: { nextRoute: PageKey.disclosures, prevRoute: PageKey.bankInfo },
  [PageKey.disclosures]: { nextRoute: PageKey.none, prevRoute: PageKey.review },
  [PageKey.approved]: { nextRoute: PageKey.cartReview, prevRoute: PageKey.none },
  [PageKey.cartReview]: { nextRoute: PageKey.paymentSigning, prevRoute: PageKey.approved },
  [PageKey.paymentSigning]: { nextRoute: PageKey.none, prevRoute: PageKey.cartReview },
  [PageKey.wirelessPlan]: { nextRoute: PageKey.none, prevRoute: PageKey.paymentSigning },
  [PageKey.addCard]: { nextRoute: PageKey.paymentSigning, prevRoute: PageKey.paymentSigning },
  [PageKey.esign]: { nextRoute: PageKey.checkoutCard, prevRoute: PageKey.paymentSigning },
  [PageKey.verifyItsYou]: { nextRoute: PageKey.none, prevRoute: PageKey.useMyApproval },
  [PageKey.needHelp]: { nextRoute: PageKey.none, prevRoute: PageKey.verifyItsYou },
  [PageKey.checkoutCard]: { nextRoute: PageKey.none, prevRoute: PageKey.none },
};

function isBlank(address: string): boolean {
  return address === 'undefined' || address.trim().length <= 0;
}

export function AddressIsBlank(address: Address): boolean {
  return isBlank(address.zip) || isBlank(address.line1) || isBlank(address.city) || isBlank(address.state);
}

export function GetNextPage(currentPage: PageKey): PageKey {
  const routeInfo = routesOrder[currentPage];

  return routeInfo.nextRoute;
}

export function GetPrevPage(currentPage: PageKey): PageKey {
  const routeInfo = routesOrder[currentPage];

  return routeInfo.prevRoute;
}
